import { StatisticsCountsService } from './counts';
import { StatisticsByDatesService } from './by-dates';
import { StatisticsAppointmentsService } from './appointments';

export class StatisticsService {
  public static Counts = StatisticsCountsService;
  public static ByDates = StatisticsByDatesService;
  public static Appointments = StatisticsAppointmentsService;
}
